import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from '../config/oidc'

import ui from '@/store/modules/ui'
import notifications from '@/store/modules/notifications'
import fair from '@/store/modules/fair'
import insurance from '@/store/modules/insurance'
import user from '@/store/modules/user'
import * as core from '@/store/modules/core'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'OneShop_BEX',
  storage: window.localStorage,
  supportCircular: true,
  reducer: state => ({
    //customer: state.customer,
    //order: state.order,
    ui: state.ui,
    user: state.user,
    message: state.message
  })
})

export default new Vuex.Store({
  modules: {
    ui,
    notifications,
    fair,
    insurance,
    core,
    user,
    oidcStore: vuexOidcCreateStoreModule(oidcSettings)
  },
  state: {
    message: null
  },
  mutations: {
    setMessage(state, payload) {
      if (state.message === null || payload.message === null) {
        state.message = payload.message
      }
    }
  },
  actions: {
    setMessage(context, message) {
      context.commit('setMessage', { message: message })
    }
  },
  plugins: [vuexLocalStorage.plugin],
  getters: {
    localeKey: state => {
      return `${state.ui.i18n.locale.substring(0,1).toUpperCase()}${state.ui.i18n.locale.substring(1,2).toLowerCase()}`;
    }
  }
})
